export default {
    en: {
        doc: {
            header: 'Legal info'
        },
        faq: {
            header: 'F.A.Q.',
            contactUs: 'Submit a request',
            requestSubmit: 'Submit a request'
        },
        feedback: {
            header: 'Support Center',
            title: 'Question',
            subject: 'Subject',
            description: 'Description',
            email: 'Your email',
            type: 'Type',
            send: 'Send',
            close: 'close',
            attachment1: 'Attach files',
            attachment2: 'File size must be less than {max_file_size_in_mb} mb',
            mainSelect: 'Select a type of question',
            fallbackHeader: 'Ticket creation form is unavailable at this moment.',
            fallbackDescription: 'You can submit a ticket via our Help Center.',
            fallbackLinkText: 'Go to the Help Center',
        },
        message: {
            loading: 'Loading...',
            sending: 'Message sending<br/>Please wait...',
            sent: 'Message sent<br/>You\'ll get an answer by email.',
        },
        errors: {
            generic: 'Send error<br/>Retry later, please.',
            description: 'Description too short.',
            email: 'Invalid email.',
            emailMaxLength: 'Text length in the email field must be less than 256 characters.',
            wait: 'Send interval must be at least 1 minute',
            type: 'Specify the type of problem',
            attachmentSize: 'Attachment size must be less than {max_file_size_in_mb} megabytes',
            uploadErrorFirstTime: 'Error, can not upload file. Please try again.',
            uploadErrorSecondTime: 'Error, can not upload file. Please create your ticket without this attachment.',
            tooManyFiles: 'Too many files. Max number of attachments is {max_files_count}',
            internal: 'Oops! Something went wrong trying to send your request.',
            tryAgain: {
                text: 'Please try again later. You can also contact us',
                tos: 'here'
            },
            faqOpening: 'Oops! Something went wrong. F.A.Q. is currently unavailable.',
        },
        404: {
            pageTitle: 'Page not found.',
            pageDescription: 'It could have been removed or moved to another URL.',
            homeButton: 'Go to the homepage',
        },
        meya: {
            bubleText: 'Open chat',
            contact_us_1: 'Hello!',
            contact_us_2: 'Welcome to Hero Wars Alliance support! In this chat you can choose any category and get answers to any game-related questions.',
            contact_us_3: 'Press the button below to contact us.',
            contact_us_4: 'If you don\'t see the button, please follow',
            contact_us_4_link: 'this link',
            contact_us_5: 'We look forward to helping you on your Hero Wars journey! :)',

        }
    },
    ru: {
        doc: {
            header: 'Правовая информация'
        },
        faq: {
            header: 'Частые вопросы',
            contactUs: 'Связаться с нами',
            requestSubmit: 'Создать обращение'
        },
        feedback: {
            header: 'Центр поддержки',
            title: 'Задать вопрос',
            subject: 'Тема',
            description: 'Описание',
            email: 'Ваш email',
            type: 'Тип обращения',
            send: 'Отправить',
            close: 'закрыть',
            attachment1: 'Прикрепить файлы',
            attachment2: 'Размер файла не должен превышать {max_file_size_in_mb} мб',
            mainSelect: 'Укажите тип обращения',
            fallbackHeader: 'В данный момент невозможно создать обращение через форму обратной связи.',
            fallbackDescription: 'Вы можете создать обращение в Справочном Центре.',
            fallbackLinkText: 'Перейти в Справочный центр',
        },
        message: {
            loading: 'Загрузка...',
            sending: 'Сообщение отправляется.<br/>Ожидайте...',
            sent: 'Сообщение отправлено.<br/>В ближайшее время вы получите ответ<br/>на указанный электронный адрес почты.',
        },
        errors: {
            generic: 'Во время отправки возникла ошибка<br/>Попробуйте повторить позже.',
            description: 'Опишите проблему подробней.',
            email: 'Проверьте введенный email.',
            emailMaxLength: 'Текст в поле email не должен превышать 255 символов.',
            wait: 'Интервал между отправкой сообщений не может быть меньше одной минуты',
            type: 'Укажите тип проблемы',
            attachmentSize: 'Размер вложения не может превышать {max_file_size_in_mb} мегабайт',
            uploadErrorFirstTime: 'Ошибка: не удалось загрузить файл. Попробуйте еще раз.',
            uploadErrorSecondTime: 'Ошибка: не удалось загрузить файл. Пожалуйста, отправьте запрос без этого вложения.',
            tooManyFiles: 'Слишком много файлов. Максимальное количество вложений - {max_files_count}',
            internal: 'Ой! Что-то пошло не так, и ваше сообщение не было отправлено.',
            tryAgain: {
                text: 'Пожалуйста, повторите попытку через несколько минут или попробуйте написать',
                tos: 'сюда'
            },
            faqOpening: 'Ой! Что-то пошло не так. Раздел "Частые вопросы" временно недоступен.',
        },
        404: {
            pageTitle: 'Страница не найдена.',
            pageDescription: 'Возможно, она была перемещена или удалена.',
            homeButton: 'Вернуться на главную страницу',
        },
        meya: {
            bubleText: 'Открыть чат',
            contact_us_1: 'Привет!',
            contact_us_2: 'Добро пожаловать в поддержку Hero Wars Alliance! В чате вы сможете выбрать интересующую категорию и получить ответы на любые игровые вопросы.',
            contact_us_3: 'Нажмите на кнопку ниже, чтобы связаться с нами.',
            contact_us_4: 'Если вы не видите у себя кнопку, пожалуйста, перейдите по',
            contact_us_4_link: 'этой ссылке.',
            contact_us_5: 'Мы будем рады помочь вам :)'
        }
    },
};
